<template>
  <role-info-form @on-submit="addRole"></role-info-form>
</template>

<script>
import RoleInfoForm from "./RoleInfoForm.vue";
import { role_router_names } from "@/routes/routes";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
export default {
  components: { RoleInfoForm },
  methods: {
    addRole(form) {
      this.$axios
        .post(service_paths.roles, form)
        .then(() => {
          Message.success(this.$t("common.add_success"));
          this.$router.push({ name: role_router_names.listPage });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style></style>
